/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;
        this.exitState = `${this.id}-exit-intent`;
        this.lastPointerY = null;
        this.lastPointerTime = 0;
        this.desktopExitTriggered = false;
        this.pageEnterTime = Date.now();

        if (Shopify.designMode) {
          this.shopifySelectHandler = (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          };
          this.shopifyDeselectHandler = this.close.bind(this);
          
          document.addEventListener('shopify:section:select', this.shopifySelectHandler);
          document.addEventListener('shopify:section:deselect', this.shopifyDeselectHandler);
        } else if (!(getCookie(this.cookie) || getCookie('uv-popup-success')) && (this.dataset.showOnMobile === 'true'
          || theme.mediaMatches.md)) {
          
          if (this.dataset.trigger === 'delay') {
            setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
          } else if (this.dataset.trigger === 'exit') {
            this.initExitIntent();
          } else if (this.dataset.trigger === 'pages') {
            const viewsKey = `uv-views-${this.id}`;
            const currentViews = parseInt(sessionStorage.getItem(viewsKey) || '0', 10) + 1;
            sessionStorage.setItem(viewsKey, currentViews.toString());
            
            const targetViews = parseInt(this.dataset.pagesViewed || '3', 10);
            if (currentViews >= targetViews) {
              this.open();
            }
          }
        }
        
        // Inicializa o funcionamento de multietapa (Micro-Yes)
        this.initMicroYesFlow();
      }

      initMicroYesFlow() {
        this.btnYes = this.querySelector('.js-micro-yes-btn');
        this.step1 = this.querySelector('.uv-popup__step-1');
        this.step2 = this.querySelector('.uv-popup__step-2');
        this.form = this.querySelector('form');

        // Checar se a URL indica que viemos de um desafio reCAPTCHA recém-solucionado
        const params = new URLSearchParams(window.location.search);
        if (params.has('popup_success')) {
            params.delete('popup_success');
            const newSearch = params.toString() ? `?${params.toString()}` : '';
            const newUrl = window.location.pathname + newSearch + window.location.hash;
            window.history.replaceState({}, document.title, newUrl);
            
            this.open();
            if (this.step1 && this.step2) {
               this.step1.classList.add('hidden');
               this.step2.classList.remove('hidden');
               this.showSuccessDOM();
            }
        }

        if (this.btnYes && this.step1 && this.step2) {
          this.btnYes.addEventListener('click', () => {
             // Animação suave entre os steps usando as classes utilitárias
             this.step1.classList.add('hidden');
             this.step2.classList.remove('hidden');
             // Foca no campo de e-mail automaticamente
             const emailInput = this.step2.querySelector('input[type="email"]');
             if (emailInput) emailInput.focus();
          });
        }
        
        // --- Fluxo de Submissão sem F5 com Blindagem Avançada contra Scripts de Proteção Nativos ---
        if (this.form) {
          // O Shopify tem um script global (se o reCAPTCHA Invisível v3 estiver ligado no painel Admin)
          // que captura submit antes do AJAX, busca o token no Google e por fim executa `form.submit()`.
          // Essa chamada direta em JavaScript ignora eventos 'submit' normais. Por isso o browser navegava pra /challenge ignorando nosso Fetch!
          // Solução Nível Mundial: Interceptar à força funções da API DOM nativa para esse form.
          if (!window.__uv_shop_submit_hooked) {
             const originalFormSubmit = HTMLFormElement.prototype.submit;
             HTMLFormElement.prototype.submit = function() {
                if (this.classList.contains('uv-popup__form')) {
                   // Se for o nosso form, avisa o interceptador Ajax criado na linha abaixo em vez de enviar e mudar de tela
                   this.dispatchEvent(new CustomEvent('uv-ajax-hook'));
                } else {
                   originalFormSubmit.call(this);
                }
             };
             window.__uv_shop_submit_hooked = true;
          }

          const executeAjaxSubmit = async (e) => {
            if (e) e.preventDefault();
            const submitBtn = this.form.querySelector('button[type="submit"]');
            if (submitBtn) submitBtn.classList.add('is-loading');

            const errorHolder = this.form.querySelector('.form__field-error');
            if (errorHolder) errorHolder.remove();

            try {
              const formData = new FormData(this.form);
              if (!formData.has('return_to')) {
                const urlObj = new URL(window.location.href);
                urlObj.searchParams.set('popup_success', '1');
                formData.append('return_to', urlObj.pathname + urlObj.search);
              }
              const urlPost = this.form.action || window.location.pathname;

              const response = await fetch(urlPost, {
                method: 'POST',
                body: formData,
                headers: { 'Accept': 'text/html' }
              });

              const text = await response.text();
              const urlRetorno = response.url || "";

              if (urlRetorno.includes('/challenge') || text.includes('shopify-challenge__container')) {
                 // Bloqueio de Política de Segurança impede Iframe. O jeito oficial é submeter a tag FORM em si
                 // e deixar o browser navegar, pra depois recuperarmos pela URL ?popup_success=1
                 const tempForm = document.createElement('form');
                 tempForm.method = 'POST';
                 tempForm.action = urlPost;
                 tempForm.style.display = 'none';
                 for (let [key, value] of formData.entries()) {
                     const input = document.createElement('input');
                     input.type = 'hidden';
                     input.name = key;
                     input.value = value;
                     tempForm.appendChild(input);
                 }
                 document.body.appendChild(tempForm);
                 tempForm.submit();
              } 
              else if (response.redirected && urlRetorno.includes('contact_posted=true') || text.includes('id="' + this.form.id + '-success"')) {
                this.showSuccessDOM();
              } 
              else if (response.redirected) {
                 this.showSuccessDOM();
               }
              else {
                const doc = new DOMParser().parseFromString(text, 'text/html');
                const errorMessage = doc.querySelector('.form__field-error') || doc.querySelector('.errors');
                if (errorMessage) {
                   const errText = errorMessage.innerText || 'Verifique o e-mail digitado.';
                   const field = this.form.querySelector('.uv-popup__field');
                   field.insertAdjacentHTML('beforeend', `<p class="form__field-error" style="color:red; font-size:12px; margin-top:8px;">${errText}</p>`);
                }
                if (submitBtn) submitBtn.classList.remove('is-loading');
              }
            } catch (err) {
              if (submitBtn) submitBtn.classList.remove('is-loading');
            }
          };

          this.form.addEventListener('submit', executeAjaxSubmit);
          this.form.addEventListener('uv-ajax-hook', executeAjaxSubmit);
        }
      }

      showSuccessDOM() {
        const h2Str = this.dataset.successHeading || "Cadastro confirmado!";
        const pStr = this.dataset.successText || "Seu desconto está a caminho da caixa de entrada.";
        this.step2.innerHTML = `
          <div class="uv-popup__success alert" tabindex="-1" autofocus style="text-align: center;">
            <svg style="margin: 0 auto 16px; width: 48px; height: 48px; color: #18b67b" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            <h2 class="uv-popup__heading h2">${h2Str}</h2>
            <div class="uv-popup__description rte"><p>${pStr}</p></div>
            <button type="button" class="uv-popup__dismiss link js-close-modal" style="margin-top: 16px;">Fechar</button>
          </div>
        `;
        
        // Reatribuir evento de fechar pro novo DOM
        const closeBtn = this.step2.querySelector('.js-close-modal');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => this.close());
        }

        // Salvar que o pop-up NUNCA mais deve ser visto por centenas de dias (400)
        setCookie(this.cookie, 'true', 400);
        setCookie('uv-popup-success', 'true', 400); // Sinal global para não abrir outros pop-ups
        this.successTimeout = setTimeout(() => this.close(), 6000); // Fecha automático após 6s
      }



      initExitIntent() {
        if (theme.mediaMatches.md) {
          this.mouseMoveHandler = this.mouseMoveHandler || this.handleMouseMove.bind(this);
          document.addEventListener('mousemove', this.mouseMoveHandler, { passive: true });
        }

        this.popStateHandler = this.popStateHandler || this.handlePopState.bind(this);
        window.addEventListener('popstate', this.popStateHandler);

        if (!history.state || !history.state[this.exitState]) {
          history.pushState(
            {
              ...(history.state || {}),
              [this.exitState]: true
            },
            '',
            window.location.href
          );
        }
      }

      open() {
        super.open();
      }

      /**
       * Triggers when the web component is removed from the DOM
       */
      disconnectedCallback() {
        if (this.mouseMoveHandler) {
          document.removeEventListener('mousemove', this.mouseMoveHandler);
        }

        if (this.popStateHandler) {
          window.removeEventListener('popstate', this.popStateHandler);
        }

        if (this.shopifySelectHandler) {
          document.removeEventListener('shopify:section:select', this.shopifySelectHandler);
          document.removeEventListener('shopify:section:deselect', this.shopifyDeselectHandler);
        }

        if (this.successTimeout) {
          clearTimeout(this.successTimeout);
        }
      }

      /**
       * Handles 'mouseleave' events on the body.
       * @param {object} evt - Event object.
       */
      handleMouseMove(evt) {
        if (!theme.mediaMatches.md || (getCookie(this.cookie) || getCookie('uv-popup-success')) || this.hasAttribute('open') || this.desktopExitTriggered) return;

        const now = Date.now();
        const onPageLongEnough = now - this.pageEnterTime >= 6000;

        if (this.lastPointerY !== null) {
          const deltaY = this.lastPointerY - evt.clientY;
          const deltaTime = now - this.lastPointerTime;
          const nearTopEdge = evt.clientY <= 8;
          const movingUpFast = deltaY >= 140 && deltaTime > 0 && deltaTime <= 180;

          if (onPageLongEnough && nearTopEdge && movingUpFast) {
            this.desktopExitTriggered = true;
            this.open();
            return;
          }
        }

        this.lastPointerY = evt.clientY;
        this.lastPointerTime = now;
      }

      handlePopState() {
        if ((getCookie(this.cookie) || getCookie('uv-popup-success')) || this.hasAttribute('open')) return;

        this.open();

        window.setTimeout(() => {
          if (!history.state || !history.state[this.exitState]) {
            history.pushState(
              {
                ...(history.state || {}),
                [this.exitState]: true
              },
              '',
              window.location.href
            );
          }
        }, 0);
      }

      /**
       * Handles 'close' events on the modal.
       */
      close() {
        super.close();
        const dismissDays = parseInt(this.dataset.dismissDays, 10);
        setCookie(this.cookie, 'true', isNaN(dismissDays) ? 7 : dismissDays);
      }
    }

    customElements.define('pop-up', PopUp);
  });
}
